import type { deDialer } from './de.dialer';

/** English dialler texts. Reference: de.dialer.ts */
export const enDialer: Record<keyof typeof deDialer, string> = {
  'dialer.poolTitle': 'Take calls',
  'dialer.poolHint': 'Once you are ready the system dials for you and connects you to customers who pick up.',
  'dialer.assignedTitle': 'Call your records',
  'dialer.assignedHint': 'The system works through your own records one after another.',

  'dialer.acceptCalls': 'Take calls',
  'dialer.start': 'Start dialler',
  'dialer.stop': 'Stop dialler',
  'dialer.stopAccepting': 'Stop taking calls',
  'dialer.pause': 'Pause',
  'dialer.resume': 'Continue',
  'dialer.pauseHint': 'After a break you make yourself available again on purpose.',

  'dialer.state.OFFLINE': 'Not ready',
  'dialer.state.ONLINE': 'Not ready',
  'dialer.state.AVAILABLE': 'Ready',
  'dialer.state.DIALING': 'Dialling',
  'dialer.state.RINGING': 'Ringing',
  'dialer.state.IN_CALL': 'On a call',
  'dialer.state.WRAP_UP': 'Wrapping up',
  'dialer.state.PAUSED': 'Paused',
  'dialer.state.RECONNECTING': 'Reconnecting',

  'dialer.manualTitle': 'Make a single call',
  'dialer.manualHint': 'For one call on its own, independent of the dialler.',
  'dialer.manualBlocked': 'Stop taking calls first to make a single call.',

  'dialer.runtimeTitle': 'Calling in this campaign',
  'dialer.runtimeCallers': 'Callers ready',
  'dialer.runtimeWaiting': 'Customers waiting',
  'dialer.runtimeIdle': 'Nobody is calling in this campaign right now.',
  'dialer.help.waiting':
    'Customers who picked up and are waiting for a free caller. This time is not billed.',

  'queueMusic.title': 'Hold music',
  'queueMusic.hint': 'One audio file per campaign, WAV or MP3, up to 5 MB. It plays on a loop.',
  'queueMusic.upload': 'Choose a file',
  'queueMusic.current': 'Stored',
  'queueMusic.remove': 'Remove',
  'queueMusic.none': 'No hold music of your own has been stored.',
  'queueMusic.saved': 'The hold music has been saved.',

  'error.campaign.stopped': 'This campaign is stopped. Please contact your administration.',
  'error.campaign.calls_in_progress':
    'Calls are running in this campaign. Please wait until they have finished.',
  'error.queueMusic.empty': 'Please choose an audio file.',
  'error.queueMusic.too_large': 'The file is too large. Up to 5 MB is allowed.',
  'error.queueMusic.invalid_format': 'Please upload a WAV or MP3 file.',
};
